import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

import normalImg from '../assets/projects/varietal/varietal-normal-img.webp';
import clayImg from '../assets/projects/varietal/varietal-clay-img.webp';
import middleImg from '../assets/projects/varietal/varietal-middle-img.webp';
import gif1 from '../assets/projects/varietal/varietal-gif-1.webp';
import gif2 from '../assets/projects/varietal/varietal-gif-2.webp';

const Varietal = () => {
  return (
    <ProjectLayout
      title="Varietal"
      description={[
        "Created the assembly journey of the Varietal armchair, showcasing the modern craftsmanship of a timeless furniture piece — 'the chair'.",
        'This personal project allowed me to refine my 3D modelling, animation, and storytelling skills, using Blender, After Effects, and Premiere Pro.',
      ]}
      credits={['3D Modelling', 'Animation', 'Storytelling']}
    >
      <div className="pm-video">
        <video controls playsInline preload="metadata">
          <source src="/videos/varietal.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="pm-row">
        <img src={gif1} alt="Assembly GIF 1" />
        <img src={gif2} alt="Assembly GIF 2" />
      </div>

      <img className="pm-full" src={middleImg} alt="Middle Section" />

      <div className="pm-row">
        <img src={normalImg} alt="Normal View" />
        <img src={clayImg} alt="Clay Render" />
      </div>
    </ProjectLayout>
  );
};

export default Varietal;
